import { BaseInput } from './../base-input';
import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { MakeProvider } from "../../abstract-custom-control";
import { ModelData } from '../../../base-models/model-data';
import { ModalSize } from '../../../base-models/modal-size';
import { TextAreaModalComponent } from './text-area-modal.component';
import { QueryParameter } from '../../../base-models/query-parameter';
import { ModalService } from '../../../base-services/modal.service';


@Component({
    selector: 'yt-text-area',
    templateUrl: './text-area.component.html',
    providers: [ MakeProvider(TextAreaComponent)],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextAreaComponent extends BaseInput {
    constructor(protected changeDetectorRef: ChangeDetectorRef,
                protected modalService: ModalService
    ){
        super(changeDetectorRef);
    }

    @Input() Height: number = 2;

    onKeyDown(event){
        if(event.keyCode == 13){
            event.stopPropagation();
        }
    }

        // Otvara modalnu masku
        openModal() {
            let modelData = new ModelData(null);
          modelData.ModalSize = ModalSize.Lg;
            modelData.UpdateComponent = TextAreaModalComponent;

            let valueParameter = new QueryParameter('Vrednost', this.value);
            let maxLengthParameter = new QueryParameter('MaxLength', this.MaxLength);
            let labelParameter = new QueryParameter('Label', this.Label);

            if(modelData){
                this.modalService.ShowModal(0, modelData, null, true, [
                    valueParameter,
                    maxLengthParameter,
                    labelParameter
                ])
                .result.then(result=>{
                    // this.writeValue(result);
                    if(result){
                    this.value = result;
                    this.changeDetectorRef.markForCheck();
                }
                }).catch((e) => (e));
            }
            


        }
}
